module.exports = __webpack_public_path__ + "4ce946a3ee5fde0844d8c49b6a0643cf.MP3";